/* ============================================================
   ESPIONAGE PROTECTABLES 2.0 — Homepage interactions (Shopify)
   Ported from Claude Design app.js. Tweaks panel + edit-mode
   removed; "add to cart" wired to Shopify's AJAX cart.
   ============================================================ */
(function () {
  'use strict';
  var root = document.documentElement;

  function esc(s) {
    return String(s).replace(/[&<>]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c];
    });
  }

  /* ---------- Sticky header condense ---------- */
  var hdr = document.querySelector('.hdr');
  function onScroll() {
    if (!hdr) return;
    if (window.scrollY > 8) hdr.classList.add('is-stuck');
    else hdr.classList.remove('is-stuck');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Search bar toggle ---------- */
  var searchBtn = document.getElementById('searchBtn');
  var searchBar = document.getElementById('searchBar');
  var searchInput = document.getElementById('searchInput');
  var searchClose = document.getElementById('searchClose');
  function openSearch() {
    searchBar.hidden = false; searchBtn.setAttribute('aria-expanded', 'true');
    setTimeout(function () { searchInput && searchInput.focus(); }, 20);
  }
  function closeSearch() {
    searchBar.hidden = true; searchBtn.setAttribute('aria-expanded', 'false');
  }
  if (searchBtn) searchBtn.addEventListener('click', function () { searchBar.hidden ? openSearch() : closeSearch(); });
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchInput) searchInput.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });

  /* ---------- Mobile drawer ---------- */
  var drawer = document.getElementById('drawer');
  var menuBtn = document.getElementById('menuBtn');
  function openDrawer() {
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    menuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 320);
  }
  if (menuBtn) menuBtn.addEventListener('click', openDrawer);
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) closeDrawer();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
  });

  /* ---------- Toast ---------- */
  var toast = document.getElementById('toast');
  var toastTimer;
  function showToast(html) {
    if (!toast) return;
    toast.innerHTML = html;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-show'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-show');
      setTimeout(function () { toast.hidden = true; }, 240);
    }, 2600);
  }

  /* ---------- Cart count ---------- */
  var cartCount = document.getElementById('cartCount');
  function setCartCount(n) {
    if (!cartCount) return;
    cartCount.textContent = n;
    cartCount.hidden = !(n > 0);
  }
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); })
      .catch(function () {});
  }
  refreshCart();

  /* ---------- Add to cart (real Shopify AJAX cart) ---------- */
  document.querySelectorAll('form.add-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.add');
      var id = form.querySelector('[name="id"]');
      var name = form.getAttribute('data-product') || 'Item';
      if (!id || !id.value) { form.submit(); return; }
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id.value, quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          if (btn) { btn.textContent = 'Added ✓'; btn.classList.add('is-added'); }
          showToast('Added to cart <b>&middot; ' + esc(name) + '</b>');
          refreshCart();
          setTimeout(function () {
            if (btn) { btn.textContent = original; btn.classList.remove('is-added'); btn.disabled = false; }
          }, 1400);
        })
        .catch(function () {
          // graceful fallback: hard navigate via native form post
          form.submit();
        });
    });
  });

  /* ---------- Email capture (Shopify newsletter form does the real work;
     this only handles the no-JS-needed inline validation polish) ---------- */
  var signupForm = document.getElementById('signupForm');
  if (signupForm && signupForm.getAttribute('data-faux') === 'true') {
    signupForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = document.getElementById('signupEmail');
      var msg = document.getElementById('signupMsg');
      var ok = email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim());
      if (!ok) {
        msg.hidden = false; msg.style.color = '#b00020';
        msg.textContent = 'Please enter a valid email address.';
        return;
      }
      msg.hidden = false; msg.style.color = '';
      msg.textContent = "You're in. Check your inbox for your 10% code.";
      email.value = '';
    });
  }

  /* ---------- Reveal on scroll ---------- */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    root.classList.add('reveal-on');
    document.querySelectorAll('.grid-cards [data-reveal]').forEach(function (el, i) {
      el.style.setProperty('--i', i);
    });
    var els = [].slice.call(document.querySelectorAll('[data-reveal]'));
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
      setTimeout(function () { els.forEach(function (el) { el.classList.add('in'); }); }, 2600);
    } else {
      els.forEach(function (el) { el.classList.add('in'); });
    }
  }
})();
